/**
 * @file    Modal.css
 *
 *          Applies common styling to all modals.
 *
 * @author  Bryan Hoang <bryan@kingsds.network>
 * @date    July 2022
 */

.ReactModal__Overlay {
  z-index: 20;
}

.ReactModal__Body--open #sidebar,
.ReactModal__Body--open .content {
  filter: blur(4px);
}

/* Content */

.ReactModal__Content > * {
  padding-left: 40px;
  padding-right: 40px;
}

.ReactModal__Content > *:last-child {
  padding-bottom: 40px;
}

/* Header */

.ReactModal__Content > header {
  min-height: 75px;
  background-color: var(--primary-hue-main);
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 20px;
}

.ReactModal__Content > header > h2,
.ReactModal__Content > header > p {
  margin: 0;
}

.ReactModal__Content > header > h2 {
  font-size: 1.25em;
  font-weight: bold;
  color: #fff;
}

.ReactModal__Content > header > p {
  color: #e5e5e5;
}

/* Close Button */

.ReactModal__Content button.close {
  background: none;
  border: none;
  position: absolute;
  top: 26px;
  right: 24px;
  padding: 0;
  cursor: pointer;
  height: 22.5px;
  width: 22.5px;

  img {
    transition: opacity 0.2s ease-in-out;
    opacity: 0.8;
    filter: brightness(0) saturate(100%) invert(100%) sepia(3%) saturate(12%)
      hue-rotate(103deg) brightness(105%) contrast(105%);
  }

  img:hover {
    opacity: 1;
  }
}

.ReactModal__Content button.close:focus-visible {
  background-color: var(--primary-hue-lighter);
  outline: 2px solid white;
  outline-offset: 2px;

  border-radius: 0.5px;

  z-index: 1;
}

.ReactModal__Content > p {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1.1em;
  font-weight: 700;
}

/* Button Bar */

.ReactModal__Content > .buttonBar {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: 32px;
}

/* Invalid Form */

.ReactModal__Content.invalid > header {
  background-color: var(--error-hue);
}

/*
Colors inputs as red when the modal is in an invalid state as determined by business logic, 
not the browser marking empty `required` inputs as invalid automatically.
*/
.ReactModal__Content.invalid input:invalid {
  border-color: var(--error-hue);
}

.ReactModal__Content.invalid form p.errorMessage {
  margin: 0;
  padding-top: 1rem;
  color: var(--error-hue);
  margin-bottom: 0;
}

@media only screen and (max-width: 480px) {
  .ReactModal__Content {
    max-width: 100%;
  }
}

.modal-close-icon {
  color: white;
  width: 100%;
  height: 100%;
  opacity: 0.8;
}

.modal-close-icon:hover {
  opacity: 1;
}
